<template>
    <b-button-group>
        <b-button @click="prevClicked">&lt;</b-button>
        <b-button @click="resetClicked" style="width:130px">{{dateLabel}}</b-button>
        <b-button @click="nextClicked">&gt;</b-button>
    </b-button-group>  
</template>

<script>
export default {
    props: {
        date: null,
        type: {
            type: String,
            default: 'month'
        }
    },
    data: function() {
        return {
            resetDate: this.$moment(),
            selectedDate: this.$moment(),
            monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"]
        }
    },
    computed: {
        dateLabel() {
            if(this.type == 'month') {
                return `${this.monthNames[this.selectedDate.month()]} ${this.selectedDate.year()}`
            } 
            return this.selectedDate.year();
        },
        changeValue() {
            return this.type == 'month' ? 'months': 'years';
        }
    },
    mounted() {
        if(!this.date) return;
        this.selectedDate = this.date;
        this.resetDate = this.date;
    },
    methods:{
        resetClicked() {
            this.selectedDate = this.resetDate;
            this.monthChanged()
        },
        prevClicked() {
            this.selectedDate = this.$moment(this.selectedDate).add(-1, this.changeValue);
            this.monthChanged()
        },
        nextClicked() {
            this.selectedDate = this.$moment(this.selectedDate).add(1, this.changeValue);
            this.monthChanged()
        },

        monthChanged() {
            this.$emit("onDateChanged", this.selectedDate);
        },        
    }
}
</script>

<style>

</style>